import React from 'react';
import { Button } from '@bsf/force-ui';
import { __ } from "@wordpress/i18n";
import { color } from '@wordpress/icons';
import { Check } from 'lucide-react';

const Welcome = ({ setCurrentStep }) => {
    return (
        <div className="bg-background-primary border-[0.5px] items-start justify-center border-subtle rounded-xl shadow-sm mb-6 p-10 flex flex-col" style={{ maxWidth: '45%' }}>
            <div className="px-1">
                <div className="flex flex-col">
                    <h1 className="m-0 mb-4 text-2xl">
                        <span className="block w-full">{__(
                            "Welcome To Schema Pro Setup Wizard!",
                            "wp-schema-pro"
                        )}
                        </span>
                    </h1>
                    <span className="text-md font-medium  pt-1 m-0 mb-6" style={{ fontSize: '1rem'  }}>
                        {__(
                            "Boost your website SEO in a few clicks. No coding skills needed.",
                            "wp-schema-pro"
                        )}
                    </span>
                </div>
                <img
                    alt="Welcome"
                    className="w-full mb-6 mt-6"
                    style={{ paddingTop: '24px' }}
                    src={`${schemaSettingsData.welcome_banner}`}
                    loading="lazy"
                />

                <div className="flex flex-col">
                    <span className="flex items-center text-sm font-medium text-text-tertiary  mb-6 schema-88-width" style={{ lineHeight: '1.5em', paddingTop: '16px' }}>
                        <Check className="mr-2"  size={38}  />
                        {__(
                            "Schema Pro adds Google-recommended schema markups across your site and specific pages. This improves your SEO and allows search engines to display rich snippets for your website.",
                            "wp-schema-pro"
                        )}
                    </span>
                    <span className="flex items-center text-sm font-medium text-text-tertiary  mb-6 schema-88-width" style={{ lineHeight: '1.5em', paddingTop: '16px' }}>
                        <Check className="mr-2" size={26} />
                        {__(
                            "This wizard is the first step to making Google understand your site better. Just fill in the required basic information. It’s easy!",
                            "wp-schema-pro"
                        )}
                    </span>
                </div>

                <hr className="w-full border-b-0 border-x-0 border-t border-solid border-t-border-subtle" style={{ marginTop: '24px', marginBottom: '24px', borderColor: '#E5E7EB' }} />

                <Button
                    className="flex items-center justify-center gap-1 schema-remove-ring"
                    iconPosition="right"
                    style={{
                        backgroundColor: "#E62A5E",
                        transition: "background-color 0.3s ease",
                        padding: "12px 30px",
                        outlineColor: "#E62A5E",
                    }}
                    onClick={() => setCurrentStep(2)}
                >
                    {__("Let's Get Started", "wp-schema-pro")}
                </Button>
            </div>
        </div>
    );
};

export default Welcome;